import React from 'react'
import { Box, useTheme } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { scrollTop } from '../../utils/functions';
import { useAppContext } from '../../App';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { COURSES_TYPES } from '../header/headerComps/navbar/navbar';

export default function MenuCustom({
  id,
  items,
  title,
  showRightArrow = [],
  addItemToPath = false,
  itemToPathById = false,
  titleRedirectTo = "",
  itemRedirectTo = "",
  routesForItems = [],
  customStyles = {},
  customActionOnItemclick = () => null,
}) {
  const {isMobile, setSelectedCategory, setSearcherText, setDrawerSelection, setModeFilter, setAppType} = useAppContext();
  
  const theme = useTheme();
  const style = styles(theme, customStyles, isMobile);
  
  const changeCategory = [
    'categorias-footer',
    'menu-gestar', 
    'menu-modalidad',
    'second-menu-drawer',
    'first-menu-drawer'
  ].includes(id);
  
  const handleItemClick = () => {
    scrollTop();
    customActionOnItemclick();
    setModeFilter(null)
  }  

  const handleOnClickById = (item) => {
    if(id === 'menu-gestar-footer'){ 
      item.name.toLowerCase() === 'cursos'?
      setAppType(COURSES_TYPES.cursos):
      item.name.toLowerCase() === 'diplomados'?
      setAppType(COURSES_TYPES.diploma): setAppType(COURSES_TYPES.secretary)
    }
    if(id === 'first-menu-drawer'){
      if(item.id >= 3)
        handleItemClick()
      else
        setDrawerSelection(item)
    }else{
      setSelectedCategory(item); 
      handleItemClick()
    }
    if(id === 'menu-modalidad-footer'){      
      setModeFilter(item)
    }
  }
  
  if(!Array.isArray(items)) return null;
  return (
    <div style={style.container}>
      { !!title &&
        <Link
          style={{...style.menuItem, ...customStyles.title}}
          to={titleRedirectTo}
          onClick={() => {handleItemClick(); setSelectedCategory(null)}}
        >
          {title}
        </Link>
      }
      <p style={style.itemSeparator}></p>
      {items.map((item, index) => {
        return(
        <div key={`key-menu-custom-${index}`}>
          <Box
            as="li"
            key={`${item.name}_${index}`}
            style={style.menuItem}
            position="relative"
            justifyContent={'space-between'}
            onClick={() =>  changeCategory && setSelectedCategory({...item, id, index})}
          >
            <Link 
              to={`${itemRedirectTo}/${addItemToPath? routesForItems[index] || item[itemToPathById? 'id' : 'name'] : ''}`}
              onClick={() =>  handleOnClickById(item)}
              onMouseOver={() =>{
                if(id === 'navbar-drop'){
                  setSelectedCategory(item)
                  setSearcherText('')
                  setModeFilter(null)
                }
              }}
              style={style.link}
            >
              {item.name}
            </Link>
            {showRightArrow[index] && <ChevronRightIcon/>}
          </Box>
          {!!title && items.length - 1 !== index && <p style={style.itemSeparator}></p>}
        </div>
      )})}
    </div>
  );
}

const styles = (theme, customStyles, isMobile) => ({
  container: {
    ...customStyles.container
  },
  menuItem:{
    display: 'flex',
    margin: 0,
    padding:0,
    color: theme.color.text.primary,
    backgroundColor: theme.background.secondary,
    ...customStyles.menuItem
  },
  itemSeparator:{
    width: '90%',
    borderBottom: '1px solid #ddd',
    ...customStyles.separator
  },
  link:{
    ...customStyles.link
  }
});
